import ConcernCategoriesFormContainer from './ConcernCategoriesFormContainer';

export default ConcernCategoriesFormContainer;
